<template>
    <v-card class="pa-0">
        <v-toolbar
        dark
        color="primary"
        flat
        extension-height="56">
            <v-btn icon @click="$emit('close')"><v-icon v-text="new_event ? 'close' : 'arrow_back'"></v-icon></v-btn>
            <!-- <v-toolbar-title> -->
            <!-- <v-text-field v-model="event_name" label="Event" class="pt-5 pl-2" dense/> -->
                <v-text-field
                  v-model="event_name"
                  single-line
                  :counter="Boolean(event_name && event_name.length > 30)"
                  maxlength="40"
                  dense
                  label="Name"
                  class="pt-4"
                  :error="error_title.length > 0"
                  :error-messages="error_title"
                  @input="error_title=''"/>
            <!-- </v-toolbar-title> -->
            <!-- <v-spacer></v-spacer> -->
            <v-toolbar-items>
                <v-btn text v-if="new_event" @click="post_event()">Create</v-btn>
                <v-btn text v-if="!new_event" @click="put_event()">Modify</v-btn>
            </v-toolbar-items>
            <template v-slot:extension>
                <v-tabs
                  align-with-title
                  background-color="primary"
                  fixed-tabs
                  :icons-and-text="true"
                  v-model="type"
                  mandatory>
                    <v-tab v-for="et in event_types" :key="et.id">
                        <span class="text-caption">{{ event_types.find(ett => ett.id == et.id).name[0].toUpperCase() + event_types.find(ett => ett.id == et.id).name.slice(1) }}</span>
                        <v-icon v-text="et.icon"/>
                    </v-tab>
                </v-tabs>
            </template>
        </v-toolbar>
            <v-container>
                <v-row class="px-sm-10 px-5 pt-sm-8 pt-1">
                    <v-col>
                        <v-row class="ma-0 pa-0">
                            <v-col cols="12" class="ma-0 pa-0">
                                <v-select
                                  return-object
                                  v-model="event_trainees"
                                  :items="available_trainees"
                                  :item-text="student => student.first_name + ' ' + student.last_name"
                                  prepend-inner-icon="account_circle"
                                  append-icon="select_all"
                                  label="Trainees"
                                  chips
                                  multiple
                                  outlined
                                  :dense="$vuetify.breakpoint.xs"
                                  :error="error_trainees.length > 0"
                                  :error-messages="error_trainees"
                                  @input="error_trainees=''"
                                  @click:append="(event_trainees.length == available_trainees.length) ? event_trainees = [] : event_trainees = available_trainees">
                            </v-select>
                            </v-col>
                        </v-row>
                        <v-row row="12" class="ma-0 pa-0 pb-0">
                            <v-col cols="6" class="mt-0 pt-0 pl-0 pb-0">
                                <v-menu
                                  v-model="date_menu_0"
                                  offset-y
                                  min-width="0"
                                  :close-on-content-click="false">
                                    <template v-slot:activator="{on}">
                                        <v-text-field
                                          prepend-inner-icon="event"
                                          v-on="on"
                                          v-model="start_date"
                                          readonly
                                          label="Start"
                                          :error="error_start_date.length > 0"
                                          :error-messages="error_start_date"/>
                                    </template>
                                    <v-date-picker
                                    v-model="start_date"
                                    :allowed-dates="d => (Date.parse(d) >= Date.parse((new Date()).toISOString().split('T')[0])) && !(end_date && Date.parse(end_date) < Date.parse(d))"
                                    @input="date_menu_0 = !date_menu_0"
                                    @change="error_start_date=''"
                                    :first-day-of-week="1"/>
                                </v-menu>
                            </v-col>
                            <v-col cols="6" class="mt-0 pt-0 pr-0 pb-0">
                                <v-menu
                                  v-model="date_menu_1"
                                  offset-y
                                  min-width="0"
                                  :disabled="!start_date"
                                  :close-on-content-click="false">
                                    <template v-slot:activator="{on}">
                                        <v-text-field
                                          :disabled="!start_date"
                                          prepend-inner-icon="event"
                                          v-on="on"
                                          v-model="end_date"
                                          readonly
                                          label="End"
                                          :error="error_end_date.length > 0"
                                          :error-messages="error_end_date"/>
                                    </template>
                                    <v-date-picker
                                      :disabled="!start_date"
                                      v-model="end_date"
                                      :allowed-dates="d => Date.parse(d) >= Date.parse(start_date)"
                                      @input="date_menu_1 = !date_menu_1"
                                      @change="error_end_date=''"
                                      :first-day-of-week="1"/>
                                </v-menu>
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>
            </v-container>
        <v-card-actions v-if="!new_event">
        <v-row justify="center" class="pa-0 ma-0">
        <v-btn text color="error" @click="delete_event()">Delete</v-btn>
        </v-row>
        </v-card-actions>
        <v-snackbar app v-model="snackbar">
            <v-icon left>error</v-icon>
            {{ snackbar_msg }}
        </v-snackbar>
    </v-card>
</template>

<script>

export default {
    name: 'EventDialog',
    props: {
        event: Object
    },
    data () {
        return {
            type: 0,
            event_name: null,
            start_date: null,
            end_date: null,
            date_menu_0: false,
            date_menu_1: false,
            event_trainees: [],
            new_event: false,

            error_title: '',
            error_trainees: '',
            error_start_date: '',
            error_end_date: '',

            snackbar_msg: '',
            snackbar: false
        }
    },
    watch: {
        event (new_val, old_val) { // eslint-disable-line no-unused-vars
            this.setup_dialog(new_val)
        }
    },
    computed: {
        event_types () {
            return this.$store.getters['trainer/event_types']
        },
        available_trainees () {
            return this.$store.getters['trainer/students'].filter(s => true || s.type == 'primary').slice().sort((a, b) => a.last_name > b.last_name)
        },
    },
    methods: {
        setup_dialog (event) {
            if (!event) {
                this.new_event = true
                this.type = 0
                this.event_name = null
                this.start_date = null
                this.end_date = null
                this.event_trainees = []
            } else {
                this.new_event = false
                this.type = this.$store.getters['trainer/event_types'].indexOf(
                    this.$store.getters['trainer/event_types'].find(et => et.id == event.type.id)
                )
                this.event_name = event.name
                this.start_date = event.start_date
                this.end_date = event.end_date
                this.event_trainees = event.trainees.map(t => this.$store.getters['trainer/students'].find(s => s.id == t.id))
                                                    .filter(t => t)
            }
        },
        form_to_event () {
            var error = false
            if (!this.event_name || this.event_name.length == 0) {
                this.error_title = "Can't be empty"
                error = true
            } if (!this.event_trainees || this.event_trainees.length == 0) {
                this.error_trainees = "Can't be empty"
                error = true
            } if (!this.start_date || this.start_date.length == 0) {
                this.error_start_date = "Can't be empty"
                error = true
            } if (!this.end_date || this.end_date.length == 0) {
                this.error_end_date = "Can't be empty"
                error = true
            }

            if (error) {
                return null
            }

            var event = {
                name: this.event_name,
                type: this.event_types[this.type],
                start_date: this.start_date,
                end_date: this.end_date,
                trainees: this.event_trainees
            }
            if (this.event) {
                event['id'] = this.event.id
            }
            return event
        },
        error (msg) {
            this.snackbar_msg = msg;
            this.snackbar = true;
        },
        async post_event () {
            var event = this.form_to_event();
            if (!event) {
                return
            }
            try {
                await this.$store.dispatch('trainer/post_event', event);
                this.$emit('modified');
                this.setup_dialog(null);
            } catch (e) {
                this.error('Error creating event.');
            }
        },
        async put_event () {
            var event = this.form_to_event();
            try {
                await this.$store.dispatch('trainer/put_event', event);
                this.$emit('modified');
            } catch (e) {
                this.error('Error modifying event.');
            }
        },
        async delete_event () {
            var event = this.form_to_event();
            try {
                await this.$store.dispatch('trainer/delete_event', event);
                this.$emit('modified');
            } catch (e) {
                this.error('Error deleting event.');
            }
        }
    },
    mounted () {
        this.setup_dialog(this.event)
    }
}

</script>
